import Calender from "../child/CalenderLayer";
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { handleUnauthorized } from "../../utils/apiHelper";
import Loader from "./../child/Loder";
import { Icon } from "@iconify/react";
import useAnalyticData from "../../hook/useAnalyticData";
import ReactApexChart from "react-apexcharts";
import DataTable from "react-data-table-component";
import { saveAs } from "file-saver";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ExcelJS from "exceljs";
import SuccessAlert from "../child/Alert/SuccessAlert";
import DangerAlert from "../child/Alert/DengerAlert";

const AnalyticLayer = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categoryData, setCategoryData] = useState([]);
  const [timeframe, setTimeframe] = useState("Monthly");
  const [category, setCategory] = useState("All");
  const [dashboard, SetDashboardData] = useState();
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedExport, setSelectedExport] = useState("");
  const [searchText, setSearchText] = useState("");

  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const {
    EarningChartSeries,
    EarningChartOptions,
    loading: chartLoading,
  } = useAnalyticData(timeframe, category);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const columns = [
    { name: "Booking ID", selector: (row) => row._id, sortable: true },
    { name: "Amount ($)", selector: (row) => row.amount, sortable: true },
    {
      name: "Booking Status",
      selector: (row) => row.bookingStatus,
      sortable: true,
    },
    {
      name: "Booking Date",
      selector: (row) => formatDate(row.transactionDate),
      sortable: true,
    },
  ];

  const customStyles = {
    table: { style: { border: "1px solid #dee2e6" } },
    headRow: {
      style: { backgroundColor: "#f8f9fa", borderBottom: "1px solid #dee2e6" },
    },
    headCells: {
      style: {
        borderRight: "1px solid #dee2e6",
        fontWeight: "bold",
        fontSize: "14px",
      },
    },
    rows: { style: { borderBottom: "1px solid #dee2e6" } },
    cells: { style: { borderRight: "1px solid #dee2e6", fontSize: "14px" } },
  };

  const filteredData = Array.isArray(items.filterBookingList)
    ? items.filterBookingList.filter(
        (item) =>
          (item._id || "")
            .toString()
            .toLowerCase()
            .includes(searchText.toLowerCase()) ||
          (item.amount || "")
            .toString()
            .toLowerCase()
            .includes(searchText.toLowerCase()) ||
          (item.storageTypeTitle || "")
            .toLowerCase()
            .includes(searchText.toLowerCase()) ||
          (item.bookingStatus || "")
            .toLowerCase()
            .includes(searchText.toLowerCase()) ||
          formatDate(item.transactionDate)
            .toLowerCase()
            .includes(searchText.toLowerCase())
      )
    : [];

  const fetchData = async (cat = category, tf = timeframe) => {
    console.log("category1...", cat);
    console.log("timeframe2...", tf);
    const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/admin-analytics-report?storageType=${cat}&timePeriod=${tf}`;
    try {
      setLoading(true);
      const response = await fetch(API_ENDPOINT, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 401) return handleUnauthorized(navigate);
      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);
      const data = await response.json();
      setItems(data.data || []);
      if (data.data.filterBookingList == []) {
        alert();
      }
    } catch (error) {
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchDashboardData = async () => {
    const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/admin-dashboard`;
    try {
      setLoading(true);
      const response = await fetch(API_ENDPOINT, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 401) return handleUnauthorized(navigate);
      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);
      const dashboarddata = await response.json();
      SetDashboardData(dashboarddata.data || []);
    } catch (error) {
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchCategoryData = async () => {
    const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/storageTypeList`;
    try {
      const response = await fetch(API_ENDPOINT, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 401) return handleUnauthorized(navigate);
      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);
      const data = await response.json();
      setCategoryData(data.storageTypes || []);
    } catch (error) {
      setCategoryData([]);
    }
  };

  useEffect(() => {
    fetchData();
    fetchCategoryData();
    fetchDashboardData();
  }, [timeframe, category]);

  const handleTimeframeChange = (e) => {
    const value = e.target.value;
    setTimeframe(value);
    console.log("category...", category);
    console.log("timeframe...", value);
  };

  const handleCategoryChange = (e) => {
    const value = e.target.value;
    console.log("category...", value);
    console.log("timeframe...", timeframe);
  };

  const clearMessage = () => {
    setTimeout(() => setErrorMessage(""), 3000);
  };

  const handleExportChange = async (event) => {
    const exportType = event.target.value;
    setSelectedExport(exportType);

    const todayStr = new Date().toISOString().split("T")[0];
    const dataToExport = filteredData;

    if (!Array.isArray(dataToExport) || dataToExport.length === 0) {
      setErrorMessage("No data available to export.");
      clearMessage();
      return;
    }

    if (exportType === "csv") {
      const csvData = dataToExport.map((item) => ({
        "Booking ID": item._id || "N/A",
        "Amount($)": item.amount != null ? item.amount : "N/A",
        "Booking Status": item.bookingStatus || "N/A",
        "Booking Date": formatDate(item.transactionDate),
      }));
      const csv = Papa.unparse(csvData, { quotes: true });
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, `Earning_${todayStr}.csv`);
    }

    if (exportType === "excel") {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Earning");
      const headerRow = worksheet.addRow([
        "Booking Id",
        "Amount",
        "Sto",
        "Booking Status",
        "Booking Date",
      ]);
      headerRow.eachCell((cell) => (cell.font = { bold: true }));

      dataToExport.forEach((item) => {
        worksheet.addRow([
          item._id || "N/A",
          item.amount != null ? item.amount : "N/A",
          item.storageTypeTitle || "N/A",
          item.bookingStatus || "N/A",
          formatDate(item.transactionDate),
        ]);
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, `hostbusiness_${todayStr}.xlsx`);
    }

    if (exportType === "pdf") {
      const pdf = new jsPDF();
      pdf.setFontSize(18);
      pdf.text("Earning Report", 14, 15);
      const headers = [
        "Booking Id",
        "Amount($)",
        "Booking Status",
        "Booking Date",
      ];
      const rows = dataToExport.map((item) => [
        item._id || "N/A",
        item.amount != null ? item.amount : "N/A",
        item.storageTypeTitle || "N/A",
        item.bookingStatus || "N/A",
        formatDate(item.transactionDate),
      ]);

      autoTable(pdf, {
        head: [headers],
        body: rows,
        headStyles: {
          fillColor: "#d83d76",
          textColor: [255, 255, 255],
          fontStyle: "bold",
        },
        startY: 25,
      });

      pdf.save(`Earning_${todayStr}.pdf`);
    }
  };

  if (loading) return <Loader />;

  return (
    <>
      {/* Summary Card */}
      <div className="row row-cols-xxxl-7 row-cols-lg-3 row-cols-sm-2 row-cols-1 gy-4">
        <div className="col">
          <div className="card shadow-none border bg-gradient-start-2 h-100">
            {errorMessage && <DangerAlert message={errorMessage} />}
            <div className="card-body p-20">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                <div>
                  <p className="fw-medium text-primary-light mb-1">
                    Total Earning
                  </p>
                  <h6 className="mb-0">${dashboard?.totalEarnings || 0}</h6>
                </div>
                <div className="w-50-px h-50-px bg-purple rounded-circle d-flex justify-content-center align-items-center">
                  <Icon
                    icon="solar:wallet-bold"
                    className="text-white text-2xl mb-0"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Chart and Filters */}
      <section className="row gy-4 mt-1">
        <div className="col-xxl-12">
          <div className="card h-100">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                <h6 className="fw-bold text-lg mb-0">
                  Earning Review By Category
                </h6>
                <div style={{ display: "flex", gap: "20px" }}>
                  <input
                    type="text"
                    className="form-control w-auto"
                    placeholder="Search..."
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                  <select
                    className="form-select form-select-sm w-auto"
                    value={category}
                    onChange={handleCategoryChange}
                  >
                    <option value="All">ALL</option>
                    {categoryData.map((item) => (
                      <option key={item._id} value={item._id}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                  <select
                    className="form-select form-select-sm w-auto"
                    value={timeframe}
                    onChange={handleTimeframeChange}
                  >
                    <option value="Weekly">Weekly</option>
                    <option value="Monthly">Monthly</option>
                    <option value="Yearly">Yearly</option>
                  </select>
                  <select
                    className="form-select form-select-sm w-auto"
                    value={selectedExport}
                    onChange={handleExportChange}
                  >
                    <option value="">Export</option>
                    <option value="pdf">PDF</option>
                    <option value="excel">Excel</option>
                    <option value="csv">CSV</option>
                  </select>
                </div>
              </div>

              <div className="mt-40">
                {chartLoading ? (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "250px" }}
                  >
                    <Loader />
                  </div>
                ) : (
                  <ReactApexChart
                    options={EarningChartOptions}
                    series={EarningChartSeries}
                    type="area"
                    height={250}
                  />
                )}
              </div>

              <div className="table-responsive scroll-sm mt-20">
                <DataTable
                  columns={columns}
                  data={filteredData}
                  pagination
                  responsive
                  highlightOnHover
                  persistTableHead
                  customStyles={customStyles}
                  noDataComponent="No Data Found"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Popular Locations Table */}
      <section className="row gy-4 mt-1">
        <div className="col-xxl-12">
          <div className="card h-100">
            <div className="card-body">
              <h6 className="fw-bold text-lg mb-0">Popular search locations</h6>
              <div className="table-responsive scroll-sm mt-20">
                <table className="table bordered-table sm-table mb-0">
                  <thead>
                    <tr>
                      <th>Location Name</th>
                      <th>Last Search Date</th>
                      <th>Search Count</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(items.popularSearchLocations) &&
                    items.popularSearchLocations.length > 0 ? (
                      items.popularSearchLocations.map((item) => (
                        <tr key={item._id}>
                          <td>{item.location}</td>
                          <td>{formatDate(item.lastSearched)}</td>
                          <td>{item.count}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center">
                          No Data Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* High-demand Storage Table */}
      <section className="row gy-4 mt-1">
        <div className="col-xxl-12">
          <div className="card h-100">
            <div className="card-body">
              <h6 className="fw-bold text-lg mb-0">
                High-demand storage types
              </h6>
              <div className="table-responsive scroll-sm mt-20">
                <table className="table bordered-table sm-table mb-0">
                  <thead>
                    <tr>
                      <th>Storage ID</th>
                      <th>Storage Type</th>
                      <th>Booked Count</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(items.highDemandStorageTypes) &&
                    items.highDemandStorageTypes.length > 0 ? (
                      items.highDemandStorageTypes.map((item) => (
                        <tr key={item._id}>
                          <td>{item.storageTypeId}</td>
                          <td>{item.storageTypeTitle}</td>
                          <td>{item.bookingCount}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center">
                          No Data Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AnalyticLayer;
